import {
	ETableStructureType,
	THandleAction,
	TShowButtons,
	TTableStructure,
} from 'services/constants/tableStructureTypes';
import { ItemWithId } from 'services/constants/types';

export type TEasTableProps<T extends ItemWithId> = {
	tableStructure: TTableStructure<keyof T>[];
	itemsIsLoading: boolean;
	items: T[] | null;
	handleAction: THandleAction;
	handleLink?: (id: number) => void;
	skeletonRows?: any[];
	highlightedRow?: number | null;
	name?: string;
	showButtons?: TShowButtons[];
};

export enum ECountryType {
	ALL = 'All',
	EU = 'EU',
	NON_EU = 'NON-EU',
	SUPPORTED = 'SUPPORTED',
}

export interface IFilterWithType extends TFilter {
	type: ETableStructureType;
}

export type TOperator = '<>' | '=' | '<' | '>' | '<=' | '>=' | 'like';

export type TFilter = {
	fieldName: string;
	value: string | number | string[] | number[] | null;
	operator: TOperator;
};
